// Copyright (c) StrangeBee 2023

import { Alert } from 'antd';
import React, { ReactElement } from 'react';

import './AlertImport.scss';

interface AlertImportProps {
    title: string;
    children?: ReactElement;
}

export const AlertImport = ({ title, children }: AlertImportProps): ReactElement => (
    <Alert
        className="import-alert"
        message={
            <div>
                <div className="import-alert__title">{title}</div>
                {children}
            </div>
        }
        type="info"
    />
);
